import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MaintenanceService {
    static isInMaintenanceMode(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bcmaintenance'),
            'checkMaintenanceMode', 
            [], 
            additionalHeaders
        );
    }
}